import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { withSiteContext } from '../../interceptors/site-context.interceptor';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { CreateCategoryRequest } from '../../models/categories/create-category-request';
import { CreateCategoryV2Request } from '../../models/categories/create-category-v2-request';
import { PageResponseCategorySelector } from '../../models/categories/category-selector-response';
import { CategoryTreeItemResponse } from '../../models/categories/category-tree-item-response';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private http: HttpClient) { }

  //Search Catecories
  searchCategories(
    siteId: string,
    searchParam: string = "",
    has_children?: boolean,
    locale: string = "",
    size: number = 10,
    page: number = 0
  ) {
    let url = environment.baseUrl + "store/admin/category/search";
    let urlenconded = new HttpParams()
      .set("siteId", siteId)
      .set("text", searchParam)
      .set("locale", locale)
      .set(
        "hasChildren",
        has_children == true || has_children == false
          ? has_children.toString()
          : ""
      )
      .set("size", size.toString())
      .set("page", page.toString());
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.get(url, { params: urlenconded, headers: headers, context: withSiteContext(siteId) });
  }

  //find Category By Id
  getCategoryById(siteId: string, catId: string) {
    let url = environment.baseUrl + "store/admin/category/detail/" + catId;

    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.get(url, { headers: headers, context: withSiteContext(siteId) });
  }

  //Add New Category
  addNewCategory(siteId: string, category: CreateCategoryRequest) {
    let url = environment.baseUrl + "store/admin/category";
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.post(url, JSON.stringify(category), { headers: headers, context: withSiteContext(siteId) });
  }

  //Update Category Data
  updateCategory(siteId: string, category: CreateCategoryRequest) {
    let url = environment.baseUrl + "store/admin/category";
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.put(url, JSON.stringify(category), { headers: headers, context: withSiteContext(siteId) });
  }

    //get category children
    getCategoryChildren(siteId: string, parentId: string) {
      let url =
        environment.baseUrl + "store/admin/category/" + parentId + "/children";

      let headers = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
      });
      return this.http.get(url, { headers: headers, context: withSiteContext(siteId) });
    }

  // ===================== API v2 (modelo i18n común I18nLabel) =====================
  // label/description viajan como I18nLabel { default_value, en, fr, ... }. La v1 de arriba se
  // mantiene para el formulario de página completa (huérfano).

  private v2Headers(): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
  }

  getCategoryByIdV2(siteId: string, catId: string) {
    const url = environment.baseUrl + "store/admin/v2/category/detail/" + catId;
    return this.http.get(url, { headers: this.v2Headers(), context: withSiteContext(siteId) });
  }

  addNewCategoryV2(siteId: string, category: CreateCategoryV2Request) {
    const url = environment.baseUrl + "store/admin/v2/category";
    return this.http.post(url, JSON.stringify(category), { headers: this.v2Headers(), context: withSiteContext(siteId) });
  }

  updateCategoryV2(siteId: string, category: CreateCategoryV2Request) {
    const url = environment.baseUrl + "store/admin/v2/category";
    return this.http.put(url, JSON.stringify(category), { headers: this.v2Headers(), context: withSiteContext(siteId) });
  }

  getCategoryChildrenV2(siteId: string, parentId: string) {
    const url = environment.baseUrl + "store/admin/v2/category/" + parentId + "/children";
    return this.http.get(url, { headers: this.v2Headers(), context: withSiteContext(siteId) });
  }

  // Selector PLANO (todos los niveles, no solo raíz) para el combo de categorías del producto.
  // Ver product-details.component.ts (comboItems / CategorySelectItem).
  getCategorySelector(
    siteId: string,
    text: string = "",
    page: number = 0,
    size: number = 50
  ) {
    const url = environment.baseUrl + "store/admin/v2/category/selector";
    const params = new HttpParams()
      .set("siteId", siteId)
      .set("text", text)
      .set("page", page.toString())
      .set("size", size.toString());
    return this.http.get<PageResponseCategorySelector>(url, { params, headers: this.v2Headers(), context: withSiteContext(siteId) });
  }

  // Lista PLANA de TODAS las categorias del site (raices e hijas), para la pantalla de listado en
  // arbol. El arbol/nivel/breadcrumb se derivan en cliente (ver categories-list.component.ts).
  getCategoryTree(siteId: string) {
    const url = environment.baseUrl + "store/admin/v2/category/tree";
    const params = new HttpParams().set("siteId", siteId);
    return this.http.get<CategoryTreeItemResponse[]>(url, { params, headers: this.v2Headers(), context: withSiteContext(siteId) });
  }

}


